<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="#28a745">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">หมายถึงฟิลด์ที่จำเป็น</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.identity") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <label>{{ studentCode }}</label>
                  </div>
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.fullname") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <label>{{ displayName }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.educationLvl") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <label>{{ levelName }}</label>
                  </div>
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.educationYear") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <label>{{ studentYear }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <label>{{ facultyName }}</label>
                  </div>
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <label>{{ departmentName }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.educationCourse") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <label>{{ programName }}</label>
                  </div>
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.consultants") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <label>{{ advisorName }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label class="no-margin-bottom"
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <AcademicYear
                        :onChanged="onAcademicYearChanged"
                        :selectedVal="academicYear"
                        :style="academicYearStyle"
                      />
                    </div>
                  </div>
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label class="no-margin-bottom"
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <Semester
                        :onChanged="onSemesterChanged"
                        :selectedVal="semester"
                        :style="semesterStyle"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleSearch()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-light btn-lg"
                    @click="handleClearScreen()"
                  >
                    {{ $t("messages.general.clearScreen") }}
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div>{{ $t("messages.chkResultRegister.registerResult") }}</div>
          <br />
          <v-card>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th class="text-center">
                      {{ $t("messages.general.seqOrder") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.classId") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.className") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.section") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.credit") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in enrollresult" :key="index">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="text-center">
                      {{ item.COURSECODE }}
                    </td>
                    <td style="white-space: nowrap">
                      {{ item.COURSENAME }}
                    </td>
                    <td class="text-center">
                      {{ item.SECTION_TEXT }}
                    </td>
                    <td class="text-center" style="white-space: nowrap">
                      {{ item.COURSEUNIT }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td style="white-space: nowrap"></td>
                    <td class="text-center">
                      {{ $t("messages.general.sumCredit") }}
                    </td>
                    <td class="text-center">
                      {{ sumCredit }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </v-card>
          <br />
          <div>{{ $t("messages.chkResultRegister.registerHistory") }}</div>
          <br />
          <v-card>
            <div class="table-responsive">
              <table class="table table-striped" id="table-1">
                <thead>
                  <tr>
                    <th class="text-center">
                      {{ $t("messages.general.seqOrder") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.classId") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.className") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.section") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.credit") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.chkResultRegister.action") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.chkResultRegister.period") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.chkResultRegister.confirmBy") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.chkResultRegister.confirmDate") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in enrolllog" :key="index">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="text-center">
                      {{ item.COURSECODE }}
                    </td>
                    <td style="white-space: nowrap">
                      {{ item.COURSENAME }}
                    </td>
                    <td class="text-center">
                      {{ item.SECTION_TEXT }}
                    </td>
                    <td class="text-center" style="white-space: nowrap">
                      {{ item.CRX }}
                    </td>
                    <td class="text-center" style="white-space: nowrap">
                      {{ item.ENROLLACTION }}
                    </td>
                    <td class="text-center" style="white-space: nowrap">
                      {{ item.ENROLLTIME }}
                    </td>
                    <td class="text-center" style="white-space: nowrap">
                      {{ item.CREATEUSERIDENG }}
                    </td>
                    <td class="text-center" style="white-space: nowrap">
                      {{ item.CREATEDATETIME }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import AcademicYear from "@/components/Dropdown/AcademicYear.vue";
import Semester from "@/components/Dropdown/Semester.vue";
import EnrollProvider from "@/services/enroll_provider";

const enrollProvider = new EnrollProvider();

export default {
  name: "chkResultRegister",
  components: {
    AcademicYear,
    Semester
  },
  data: () => ({
    academicYear: 0,
    semester: 0,
    sumCredit: 0,
    enrollresult: [],
    enrolllog: [],
    academicYearStyle: "width: 90%",
    semesterStyle: "width: 90%"
  }),
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      studentInfo: "getStudentInfo",
      studentId: "getStudentId"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
    currentUserId: function() {
      return _.isEmpty(this.studentInfo.data) ? this.userId : this.studentId;
    },
    studentCode: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.USERCODE_TXT
        : this.studentInfo.data.STUDENTCODE;
    },
    displayName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.USERNAME
        : `${this.studentInfo.data.PREFIXNAME} ${this.studentInfo.data.STUDENTNAME} ${this.studentInfo.data.STUDENTSURNAME}`;
    },
    levelName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.LEVELNAME
        : this.studentInfo.data.LEVELNAME;
    },
    studentYear: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.STUDENTYEAR
        : this.studentInfo.data.STUDENTYEAR;
    },
    facultyName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.FACULTYNAME
        : this.studentInfo.data.FACULTYNAME;
    },
    departmentName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.DEPARTMENTNAME
        : this.studentInfo.data.DEPARTMENTGROUPNAME;
    },
    programName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.PROGRAMNAME
        : this.studentInfo.data.PROGRAMNAME;
    },
    advisorName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.ADVISORNAME
        : this.studentInfo.data.ADVISORNAME;
    }
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onAcademicYearChanged(event) {
      this.academicYear = event.target.value;
    },
    onSemesterChanged(event) {
      this.semester = event.target.value;
    },
    handleClearScreen() {
      this.academicYear = this.appInfo.data.CURRENT_ACADYEAR;
      this.semester = this.appInfo.data.CURRENT_SEMESTER;
      this.sumCredit = 0;
      this.enrollresult = [];
      this.enrolllog = [];
    },
    async handleSearch() {
      this.togglePreLoader(true);
      const params = {
        token: this.token,
        request: {
          studentid: this.currentUserId,
          acadyear: this.academicYear,
          semester: this.semester,
          lang: this.currentLang
        }
      };
      this.enrollresult = await enrollProvider.getEnrollResult(params);
      if (this.enrollresult.length > 0) {
        this.sumCredit = this.enrollresult.reduce((sum, item) => {
          return sum + item.CREDITATTEMPT;
        }, 0);
      } else {
        this.sumCredit = 0;
      }
      this.enrolllog = await enrollProvider.getEnrollLog(params);
      this.togglePreLoader(false);
    }
  },
  async mounted() {
    this.tokenHealthChk();
    this.academicYear = this.appInfo.data.CURRENT_ACADYEAR;
    this.semester = this.appInfo.data.CURRENT_SEMESTER;
    await this.handleSearch();
  },
  watch: {
    async currentLang() {
      await this.handleSearch();
    }
  }
};
</script>
